import { Dictionary } from "@insite/client-framework/Common/Types";
import getIconDataSrc from "@toolkit/Framework/Common/Utilities/getIconDataSrc";
import { RequiredSpecific } from "@toolkit/Framework/Types/Common";
import { IconDefinitionProps } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

export type GoogleMapMarkerIconProps = IconDefinitionProps & Dictionary<any>;

function getGoogleMapMarkerIconByType(
    markerType: Toolkit.Theme.GoogleMap.MarkerType,
    iconDefinition: RequiredSpecific<IconDefinitionProps, "theme">,
    inline?: false,
): (props: GoogleMapMarkerIconProps) => JSX.Element;

function getGoogleMapMarkerIconByType(
    markerType: Toolkit.Theme.GoogleMap.MarkerType,
    iconDefinition: RequiredSpecific<IconDefinitionProps, "theme">,
    inline?: true,
): string;

function getGoogleMapMarkerIconByType(
    markerType: Toolkit.Theme.GoogleMap.MarkerType,
    iconDefinition: RequiredSpecific<IconDefinitionProps, "theme">,
    inline?: boolean,
): string | ((props: GoogleMapMarkerIconProps) => JSX.Element);

function getGoogleMapMarkerIconByType(
    markerType: Toolkit.Theme.GoogleMap.MarkerType,
    iconDefinition: RequiredSpecific<IconDefinitionProps, "theme">,
    inline?: boolean,
) {
    const { theme } = iconDefinition;
    const { src, ...marker } = theme.googleMap.markerByType[markerType];

    if (!src) {
        return "";
    }

    if (typeof src === "string") {
        return src;
    }

    const Icon = src;
    const iconProps = { ...marker, ...iconDefinition };

    return inline
        ? getIconDataSrc(Icon, iconProps)
        : (props: GoogleMapMarkerIconProps) => <Icon {...iconProps} {...props} />;
}

export default getGoogleMapMarkerIconByType;
